export default __webpack_public_path__ + "static/steam-efbc5a308f8067517c0cd34950b6fb17.png";